<template>
  <div
    class="alert alert-info has-icon protocol-research-line-container align-items-center d-flex flex-grow-1 cursor-pointer">
    <div class="d-flex align-items-center w-100">
      <div class="alert-icon flex-grow-0">
        <i class="fas fa-chevron-right"></i>
      </div>
      <div class="flex-grow-1">
        <template v-if="editing">
          <div class="w-100">
            <label for="researchLine">{{ message }}</label>
            <select name="researcheLine"
                    id="researchLine"
                    v-model="selectedLine"
                    class="form-control d-inline-block mr-2 w-100">
              <option value="" disabled selected>Seleccione una linea</option>
              <option :value="line.id"
                      v-for="line in lines"
                      :key="line.id">{{ line.title }}
              </option>
            </select>
            <div class="mt-3 btn-group w-100">
              <button class="btn btn-outline-primary mr-2"
                      :disabled="!selectedLine || saving"
                      @click="saveResearchLine">
                <span class="spinner-border spinner-border-sm text-white" role="status" v-if="saving">
                  <span class="sr-only">Loading...</span>
                </span>
                Guardar
              </button>
              <button class="btn btn-outline-secondary" @click="cancelEditing">
                Cancelar
              </button>
            </div>
          </div>
        </template>
        <div class="d-flex align-items-center" v-if="!editing">
          <div class="m-0 user-select-none cursor-pointer flex-grow-1">
            <span class="w-100 d-block">{{ line ? line.title : message }}</span>
            <span class="badge"
                  :class="{'badge-primary': isMainLine, 'badge-warning': !isMainLine }">
              {{ isMainLine ? 'Primaria' : 'Secundaria' }}</span>
          </div>
          <button class="btn btn-link" @click="removeResearchLine" v-if="line && !isMainLine">
            <span class="spinner-border spinner-border-sm text-primary" role="status" v-if="saving">
                <span class="sr-only">Loading...</span>
              </span>
            Quitar
          </button>
          <button class="btn btn-link" @click="editResearchLine" v-if="!readonly">
            Editar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'ProtocolResearchLine',
    props: {
      protocol: Object,
      line: Object,
      lines: Array,
      message: {
        type: String,
        default: 'Seleccione la línea de investigación',
      },
      isMainLine: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        editing: false,
        selectedLine: '',
        saving: false,
      }
    },
    methods: {
      ...mapActions({
        assignResearchLineToProtocol: 'protocols/assignResearchLine',
        removeResearchLineFromProtocol: 'protocols/removeResearchLine',
      }),
      
      ...mapMutations({
        setPrimaryLine: 'protocols/SET_PROTOCOL_PRIMARY_RESEARCH_LINE',
        setSecondaryLine: 'protocols/SET_PROTOCOL_SECONDARY_RESEARCH_LINE',
      }),
      
      editResearchLine () {
        this.editing = true
      },
      cancelEditing () {
        this.editing = false
      },
      async saveResearchLine () {
        this.saving = true
        
        const response = await this.assignResearchLineToProtocol({
          research_line: this.selectedLine,
          protocol: this.protocol,
          type: this.isMainLine ? 'principal' : 'secundaria',
        })
        
        const {
                status,
                error,
                message,
                research_line,
              } = response
        
        this.saving = false
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        if (this.isMainLine) {
          this.setPrimaryLine(research_line)
        }
        else {
          this.setSecondaryLine(research_line)
        }
        
        this.editing = false
        
        AlertManager.success(message)
      },
      async removeResearchLine () {
        this.saving = true
        
        const response = await this.removeResearchLineFromProtocol({
          research_line: this.selectedLine,
          protocol: this.protocol,
          type: this.isMainLine ? 'principal' : 'secundaria',
        })
        
        const {
                status,
                error,
                message,
              } = response
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        AlertManager.success(message)
        
        this.line   = null
        this.saving = false
      },
    },
    computed: {
      ...mapGetters({
        readonly: 'protocols/readonly',
      }),
    },
    async mounted () {
      if (this.line) {
        this.selectedLine = this.line.id
      }
    },
  }
</script>
